module.exports = {"data":[{"id":1,"title":"Sin iniciar","slug":"sin-iniciar","style":"info"},{"id":2,"title":"Iniciado","slug":"iniciado","style":"success"},{"id":3,"title":"Atrasado","slug":"atrasado","style":"danger"},{"id":4,"title":"Cancelado","slug":"cancelado","style":"danger"},{"id":5,"title":"Concluido","slug":"concluido","style":"success"}]}


//////////////////
// WEBPACK FOOTER
// ./src/cdm-frontend/json/status.json
// module id = 761
// module chunks = 0